import RE from '@module/regexp';

/**
 * 校验
 */
export default class Check {
  public static readonly Constraint = { // 约束
    // 最小长度
    Min: 2,
    MinX: 6,
    
    // 最大长度
    Max: 20,
    MaxX: 50,
    Max2X: 100,
    Max3X: 200,
    Max4X: 500,
    Max5X: 1000,
    Max6X: 3000,
    Max7X: 5000,
    
    // 真实名称
    RealNameMin: 2,
    RealNameMax: 10,
    
    // 密码
    PasswordMin: 6,
    PasswordMinX: 8,
    PasswordMax: 16,
    PasswordMaxX: 32,
    
    // 授权
    Auth: 4,
    AuthX: 6,
    
    // 时间
    Milli: 1000, // 1秒（毫秒）
    Minute: 60, // 1分钟（秒）
    Hour: 60 * 60, // 1小时（秒）
    Day: 60 * 60 * 24, // 1天（秒）
    Month: 60 * 60 * 24 * 30, // 1个月（秒）
    Year: 60 * 60 * 24 * 365, // 1年（秒）
    
    // 其他
    Phone: 11, // 手机
    Port: 65535 // 端口
  };
  public static readonly Suffix = { // 后缀
    Mail: [ // 邮箱
      'qq.com',
      '163.com',
      '126.com',
      'yeah.com',
      'sina.com',
      'sohu.com',
      'yahoo.com',
      'sogou.com',
      'outlook.com',
      'gmail.com'
    ],
    AreaCode: [ // 区号
      {
        area: '中国大陆',
        code: '+86'
      },
      {
        area: '中国香港',
        code: '+852'
      },
      {
        area: '中国澳门',
        code: '+853'
      },
      {
        area: '中国台湾',
        code: '+886'
      }
    ]
  };
  public static readonly Text = { // 文案
    ErrorInputEmpty: (name: string) => `${ name }不可为空`,
    ErrorSelectEmpty: (name: string) => `尚未选择${ name }`,
    ErrorLengthMin: (name: string, n: number) => `${ name }不可少于${ n }个字符`,
    ErrorLengthMax: (name: string, n: number) => `${ name }不可超过${ n }个字符`,
    ErrorLength: (name: string, min: number, max: number) => `${ name }仅支持${ min }-${ max }个字符`,
    ErrorSizeMin: (name: string, unit: string, n: number) => `${ name }不可小于${ n }${ unit }`,
    ErrorSizeMax: (name: string, unit: string, n: number) => `${ name }不可大于${ n }${ unit }`,
    ErrorSize: (name: string, unit: string, min: number, max: number) => `${ name }仅支持${ min }-${ max }${ unit }`,
    ErrorNoSpace: (name: string) => `${ name }不可有空格`,
    ErrorW: (name: string) => `${ name }仅支持数字、英文大小写、下划线`,
    ErrorNEC: (name: string) => `${ name }仅支持数字、英文大小写、中文`,
    ErrorNE: (name: string) => `${ name }仅支持数字、英文大小写`,
    ErrorN: (name: string) => `${ name }仅支持数字`,
    ErrorE: (name: string) => `${ name }仅支持英文大小写`,
    ErrorESmall: (name: string) => `${ name }仅支持英文小写`,
    ErrorEBig: (name: string) => `${ name }仅支持英文大写`,
    ErrorC: (name: string) => `${ name }仅支持中文`,
    ErrorCAll: (name: string) => `${ name }仅支持中文`,
    ErrorFormat: (name: string) => `${ name }格式错误`,
    ErrorDifferent: (name: string) => `${ name }两次输入不一致`
  };
  public static readonly Rule = { // 规则
    Validate: [ // 认证
      'change',
      'input',
      // 'focus',
      'blur'
    ],
    
    //----- 项 Start -----//
    Required: (name: string, type: 'input' | 'select' = 'input') => { // 必填
      return {
        trigger: [ 'change', 'blur' ],
        required: true,
        message: type === 'input'
          ? Check.Text.ErrorInputEmpty(name)
          : Check.Text.ErrorSelectEmpty(name)
      };
    },
    Length: (name: string, min: number = Check.Constraint.Min, max: number = Check.Constraint.Max) => { // 长度
      return {
        trigger: [ 'change', 'blur' ],
        min, max,
        message: Check.Text.ErrorLength(name, min, max)
      };
    },
    Size: (name: string, unit: string, min: number = Check.Constraint.Min, max: number = Check.Constraint.Max) => { // 大小
      return {
        trigger: [ 'change', 'blur' ],
        validator: async (rule: any, value: any) => {
          if (value < min) {
            return Promise.reject(Check.Text.ErrorSizeMin(name, unit, min));
          } else if (value > max) {
            return Promise.reject(Check.Text.ErrorSizeMin(name, unit, max));
          } else {
            return Promise.resolve();
          }
        }
      };
    },
    Format: (name: string, regExp: RegExp, message: string = '') => { // 格式
      return {
        trigger: [ 'change', 'blur' ],
        pattern: regExp,
        message: message || Check.Text.ErrorFormat(name)
      };
    },
    //----- 项 End -----//
    
    //----- 组 Start -----//
    UserName: (name: string = '用户名', isRequired: boolean = true) => [
      isRequired ? Check.Rule.Required(name) : {},
      Check.Rule.Format(name, RE.Format.W, Check.Text.ErrorW(name)),
      Check.Rule.Length(name, Check.Constraint.MinX, Check.Constraint.Max)
    ],
    Password: (name: string = '密码', isRequired: boolean = true) => [
      isRequired ? Check.Rule.Required(name) : {},
      Check.Rule.Format(name, RE.Format.NoSpace, Check.Text.ErrorNoSpace(name)),
      Check.Rule.Length(name, Check.Constraint.PasswordMin, Check.Constraint.PasswordMaxX)
    ],
    RealName: (name: string = '姓名', isRequired: boolean = true) => [
      isRequired ? Check.Rule.Required(name) : {},
      Check.Rule.Format(name, RE.Format.CAll, Check.Text.ErrorCAll(name)),
      Check.Rule.Length(name, Check.Constraint.RealNameMin, Check.Constraint.RealNameMax)
    ],
    Auth: (name: string = '验证码', isRequired: boolean = true) => [
      isRequired ? Check.Rule.Required(name) : {},
      Check.Rule.Format(name, RE.Format.N, Check.Text.ErrorN(name)),
      {
        trigger: [ 'change', 'blur' ],
        min: Check.Constraint.AuthX,
        message: Check.Text.ErrorLengthMin(name, Check.Constraint.AuthX)
      }
    ],
    Phone: (name: string = '手机号', isRequired: boolean = true) => [
      isRequired ? Check.Rule.Required(name) : {},
      Check.Rule.Format(name, RE.Format.Phone),
      {
        trigger: [ 'change', 'blur' ],
        min: Check.Constraint.Phone,
        message: Check.Text.ErrorLengthMin(name, Check.Constraint.Phone)
      }
    ],
    Mail: (name: string = '邮箱', isRequired: boolean = true) => [
      isRequired ? Check.Rule.Required(name) : {},
      Check.Rule.Format(name, RE.Format.Mail),
      Check.Rule.Length(name, Check.Constraint.Min, Check.Constraint.Max2X)
    ]
    //----- 组 End -----//
  };
}